
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nscaaa124aa9cfac6ccdab86e6bbf3ba93en from './en.yaml'
            i18n.addResourceBundle('en', 'caaa124aa9cfac6ccdab86e6bbf3ba93', flattenObject(nscaaa124aa9cfac6ccdab86e6bbf3ba93en), true, true);
        
        export default 'caaa124aa9cfac6ccdab86e6bbf3ba93';
    